import {Form, Formik} from 'formik'
import React, {useState} from 'react'
import {useIntl} from 'react-intl'
import * as Yup from 'yup'
import {SelectInput} from '../../widgets/components/Input/SelectInput'
import {
  dateFormatOptions,
  localeInitialValues,
  localeOptions,
  timeFormatOptions,
  timeZoneOptions,
} from '../core/_constants'
import {CustomButton} from '../../widgets/components/UI/CustomButton'
import {createLocale, getLocale, updateOtherSettings} from '../core/_requests'
import {useAuth} from '../../auth'
import {toast} from 'react-toastify'
import {getCompanyMetaIdType} from '../core/_models'
import {getLocaleData} from '../../../../_metronic/partials/layout/core/_requests'
import Skeleton from 'react-loading-skeleton'
import TagManager from 'react-gtm-module'
import {GTMEvent} from '../../../hooks/gtmHelpers'
import {id} from 'date-fns/locale'
import {ToolTipUI} from '../../widgets/components/UI/ToolTipUI'
import brandingConfig from '../../../../config/brandingConfig'

const localSchema = Yup.object().shape({
  locale: Yup.string(),
  timezone: Yup.string(),
  dateFormat: Yup.string(),
  timeFormat: Yup.string(),
  timestampFormat: Yup.string(),
})

export const Locale = ({
  key,
  getLocaleApiLoading,
  getApiLoading,
  showHelpBanners,
  setshowHelpBanners,
}: any) => {
  const I18N_CONFIG_KEY = process.env.REACT_APP_I18N_CONFIG_KEY || 'i18nConfig'
  const {currentUser, companyId} = useAuth()
  const {formatMessage} = useIntl()
  const [loading, setLoading] = useState(false)
  const [status, setStatus] = useState(true)

  const getLocaleValue = (id: number) => {
    const locale = localeOptions.find((option) => option.id === id)
    return locale ? locale.value : ''
  }

  const getTimezoneValue = (id: number) => {
    const timezone = timeZoneOptions.find((option) => option.id === id)
    return timezone ? timezone.value : ''
  }

  const getDateformatValue = (id: number) => {
    const dateformat = dateFormatOptions.find((option) => option.id === id)
    return dateformat ? dateformat.value : ''
  }

  const getTimeformatValue = (id: number) => {
    const timeformat = timeFormatOptions.find((option) => option.id === id)
    return timeformat ? timeformat.value : ''
  }

  const handleToogle = (checked: boolean) => {
    setshowHelpBanners(checked)
  }

  const onSubmit = async (values: {
    locale: string
    timezone: string
    dateFormat: string
    timeFormat: string
    timestampFormat: string
  }) => {
    try {
      setLoading(true)
      const allpromises: any[] = [
        createLocale('dateFormat', values.dateFormat, currentUser?.company[0].companyId),
        createLocale('locale', values.locale, currentUser?.company[0].companyId),
        createLocale('timeFormat', values.timeFormat, currentUser?.company[0].companyId),
        createLocale('timezone', values.timezone, currentUser?.company[0].companyId),
        updateOtherSettings(showHelpBanners, +companyId!),
      ]

      const data = await Promise.all(allpromises)

      if (data) {
        const {
          data: {success, data},
        } = await getLocale()
        if (success) {
          data.map(({key, value}: getCompanyMetaIdType) => {
            return (localeInitialValues[key] = value)
          })
          setLoading(false)
          toast.success(formatMessage({id: 'Locale updated successfully'}))
          await Locale()
          window.location.reload()
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.CreateLocaleSuccessful,
              action: 'normal',
              metadata: {
                company_id: currentUser?.company[0].companyId,
                locale: getLocaleValue(Number(values.locale)) || '',
                timezone: getTimezoneValue(Number(values.timezone)) || '',
                date_format: getDateformatValue(Number(values.dateFormat)) || '',
                time_format: getTimeformatValue(Number(values.timeFormat)) || '',
                user_id: currentUser?.userId,
                email: currentUser?.email,
              },
            },
          })
        }
      }
    } catch (err) {
      toast.error(formatMessage({id: 'Locale updated Failed'}))
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.CreateLocaleFailed,
          action: 'normal',
          metadata: {
            company_id: currentUser?.company[0].companyId,
            locale: getLocaleValue(Number(values.locale)) || '',
            timezone: getTimezoneValue(Number(values.timezone)) || '',
            date_format: getDateformatValue(Number(values.dateFormat)) || '',
            time_format: getTimeformatValue(Number(values.timeFormat)) || '',
            user_id: currentUser?.userId,
            email: currentUser?.email,
            error: err,
          },
        },
      })
    }
  }

  const Locale = async () => {
    try {
      const {
        data: {data, success},
      } = await getLocaleData()
      if (success) {
        data.forEach((e: any) => {
          if (e.key === 'locale') {
            if (e.value === 'fr_FR') {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'fr'}))
              }
            } else if (e.value === 'de_GN') {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'de'}))
              }
            } else if (e.value === 'ja_JP') {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'ja'}))
              }
            } else if (e.value === 'es_ES') {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'es'}))
              }
            } else if (e.value === 'zh_CN') {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'zh'}))
              }
            } else if (e.value === 'hi_HI') {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'hi'}))
              }
            } else if (e.value === 'bn_BN') {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'bn'}))
              }
            } else if (e.value === 'it_IT') {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'it'}))
              }
            } else if (e.value === 'ko_KO') {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'ko'}))
              }
            } else if (e.value === 'pt_PT') {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'pt'}))
              }
            } else if (e.value === 'ru_RU') {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'ru'}))
              }
            } else {
              if (status) {
                setStatus(false)
                localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: 'en'}))
              }
            }
          } else if (e.key === 'dateFormat') {
            localStorage.setItem('dateFormat', e.value)
          } else if (e.key === 'timeFormat') {
            localStorage.setItem('timeFormat', e.value)
          } else if (e.key === 'timezone') {
            localStorage.setItem('timeZone', e.value)
          }
        })
      }
    } catch (err) {
      console.log(err)
    }
  }
  return (
    <>
      <div className='locale-container p-6'>
        {getLocaleApiLoading ? (
          <>
            <div className='w-100'>
              <div>
                <Skeleton
                  width={250}
                  height={30}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />{' '}
              </div>
              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10 mt-10'>
                <div className='col-md-5 mb-10 mb-md-0'>
                  <div className='w-50'>
                    <Skeleton
                      height={20}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                  <div className='mt-2'>
                    <Skeleton
                      height={30}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                </div>
                <div className='col-md-5'>
                  <div className='w-50'>
                    <Skeleton
                      height={20}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                  <div className='mt-2'>
                    <Skeleton
                      height={30}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                </div>
              </div>
              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                <div className='col-md-5 mb-10 mb-md-0'>
                  <div className='w-50'>
                    <Skeleton
                      height={20}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                  <div className='mt-2'>
                    <Skeleton
                      height={30}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                </div>
                <div className='col-md-5'>
                  <div className='w-50'>
                    <Skeleton
                      height={20}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                  <div className='mt-2'>
                    <Skeleton
                      height={30}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                </div>
              </div>
              <div className='w-100 d-md-flex justify-content-md-end gap-4 align-items-md-end h-md-200px'>
                <div className='w-md-25 me-md-20 mt-2'>
                  <Skeleton
                    height={40}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                  />{' '}
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            {' '}
            <div className='fs-6 fw-semibold pb-4'>{formatMessage({id: 'Locale Settings'})}</div>
            <div className='mt-md-8  w-100'>
              <Formik
                initialValues={localeInitialValues}
                validationSchema={localSchema}
                onSubmit={onSubmit}
              >
                {(formik) => {
                  return (
                    <Form>
                      <div className='d-md-flex col-md-12 flex-wrap'>
                        <SelectInput
                          label={formatMessage({id: 'Locale'})}
                          fieldName={'locale'}
                          placeholder={formatMessage({id: 'Select the Locale'})}
                          formik={formik}
                          isStarRequired={true}
                          options={localeOptions}
                          toolTipText={formatMessage({id: 'Please select the language of the RecordsKeeper.AI platform to suit your comfort and preference. '})}
                          margin='me-md-6'
                          width={5}
                        />
                        <SelectInput
                          label={formatMessage({id: 'Time Zone'})}
                          fieldName={'timezone'}
                          placeholder={formatMessage({id: 'Select the Time Zone'})}
                          formik={formik}
                          isStarRequired={true}
                          options={timeZoneOptions}
                          toolTipText={formatMessage({id: 'GLOBAL.TOOLTIP.LOCALE.TIME_ZONE'})}
                          margin='me-md-6'
                          width={5}
                        />
                        <SelectInput
                          label={formatMessage({id: 'Date Format'})}
                          fieldName={'dateFormat'}
                          placeholder={formatMessage({id: 'Select the Date Format'})}
                          formik={formik}
                          isStarRequired={true}
                          options={dateFormatOptions}
                          toolTipText={formatMessage({id: 'GLOBAL.TOOLTIP.LOCALE.DATE_FORMAT'})}
                          margin='me-md-6'
                          width={5}
                        />
                        <SelectInput
                          label={formatMessage({id: 'Time Format'})}
                          fieldName={'timeFormat'}
                          placeholder={formatMessage({id: 'Select the Time Format'})}
                          formik={formik}
                          isStarRequired={true}
                          toolTipText={formatMessage({id: 'GLOBAL.TOOLTIP.LOCALE.TIME_FORMAT'})}
                          options={timeFormatOptions}
                          margin='me-md-6'
                          width={5}
                        />
                      </div>
                      <div>
                        <form className='form-check form-check-custom form-check-solid form-check-primary form-switch pb-3 pt-3'>
                          <label className='togglebtn ms-0'>
                            <input
                              className='togglebtn__input'
                              name='model.app.sidebar.default.minimize.desktop.hoverable'
                              defaultChecked={showHelpBanners}
                              id={id.toString()}
                              type='checkbox'
                              onChange={(e) => {
                                handleToogle(e.target.checked)
                              }}
                            />
                            <div className='togglebtn__fill'></div>
                          </label>
                          <div className='d-flex flex-column justify-content-end mt-2'>
                            <div className='d-flex'>
                              <div>
                                <label
                                  className='form-check-label fw-semibold font-size-13 title-notification'
                                  htmlFor={id.toString()}
                                  data-bs-toggle='tooltip'
                                  data-kt-initialized='1'
                                >
                                  {formatMessage({id: 'Help Text Banners in Dashboard'})}
                                </label>
                              </div>
                              <div>
                                <ToolTipUI
                                  tooltipText={formatMessage({
                                    id: 'Turn this switch to "Off" to hide all help text banners. Keep it "On" to display them',
                                  })}
                                />
                              </div>
                            </div>
                            <label
                              className='form-check-label text-clr58 fw-normal fs-7'
                              data-bs-toggle='tooltip'
                              data-kt-initialized='1'
                              htmlFor={id.toString()}
                            >
                              {formatMessage({
                                id: `Switch this Off to hide all help text banners across the ${brandingConfig.brandName} dashboard`,
                              })}
                            </label>
                          </div>
                        </form>
                      </div>
                      <div className='d-md-flex justify-content-md-end button-margin me-md-10'>
                        <CustomButton
                          isSubmitting={formik.isSubmitting}
                          isValid={formik.isValid}
                          buttonText={formatMessage({id: 'Save Changes'})}
                          loading={loading}
                          buttonColor='bg-primary text-white'
                          widthLoading={2}
                          marginButtom='mb-0'
                        />
                      </div>
                    </Form>
                  )
                }}
              </Formik>
            </div>
          </>
        )}
      </div>
    </>
  )
}
